import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

/* 基本布局 */
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    cache: true                  缓存页面
    parentRoute:                 设置上级页面路由(二级页面需设置)
  }
*/

/*
 * 通用路由
*/
export const constantRoutes: RouteConfig[] = [
    {
        path: "/login",
        component: () => import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
        meta: { hidden: true }
    },
    {
        path: "/error",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/error/error.vue"),
        meta: { hidden: true },
        name: "Error"
    },
    {
        path: "/",
        component: Layout,
        redirect: "/home",
        children: [
            {
                path: "home",
                component: () =>
                    import( /* webpackChunkName: "home" */ "@/views/home/index.vue"),
                name: "Home",
                meta: {
                    title: "工作台",
                    icon: "el-icon-picture-outline-round",
                }
            }
        ]
    },
];

export const asyncRoutes: RouteConfig[] = [

    {
        path: "/",
        component: Layout,
        children: [
            /*
             * 计划管理
            */
            {
                path: "plan-list",
                component: () => import( /* webpackChunkName: "plan-list" */ "@/views/plan-manage/plan-list.vue"),
                name: "PlanList",
                meta: {
                    title: "计划列表"
                }
            },
            {
                path: "participation",
                component: () => import( /* webpackChunkName: "participation" */ "@/views/plan-manage/participation.vue"),
                name: "Participation",
                meta: {
                    title: "参与列表"
                }
            },
            {
                path: "details",
                component: () => import( /* webpackChunkName: "PlanDetails" */ "@/views/plan-manage/details.vue"),
                name: "PlanDetails",
                meta: {
                    title: "计划详情",
                    parentRoute: "/plan-list",
                    cache: false
                }
            },
            {
                path: "password-watch",
                component: () => import( /* webpackChunkName: "PasswordWatch" */ "@/views/plan-manage/watch/password-watch.vue"),
                name: "PasswordWatch",
                meta: {
                    title: "淘口令监测",
                }
            },
            {
                path: "domain-watch",
                component: () => import( /* webpackChunkName: "DomainWatch" */ "@/views/plan-manage/watch/domain.vue"),
                name: "DomainWatch",
                meta: {
                    title: "IP重复监测",
                }
            },
            {
                path: "equipment-watch",
                component: () => import( /* webpackChunkName: "EquipmentWatch" */ "@/views/plan-manage/watch/equipment.vue"),
                name: "EquipmentWatch",
                meta: {
                    title: "设备重复监测",
                }
            },

            /*
             * 服务管理
            */
            {
                path: "/list",
                component: () => import( /* webpackChunkName: "list" */ "@/views/skill/list.vue"),
                name: "skillList",
                meta: {
                    title: "服务列表",
                    icon: "el-icon-help",
                }
            },
            {
                path: "/form",
                component: () => import( /* webpackChunkName: "form" */ "@/views/skill/form.vue"),
                name: "skillForm",
                meta: {
                    title: "服务编辑",
                    cache: false,
                    parentRoute: "/list",
                }
            },


            /*
            *数据中心
            */
            {
                path: "/dataSummarize",
                component: () => import(/* webpackChunkName: "dataSummarize" */ "@/views/data/dataSummarize.vue"),
                name: "dataSummarize",
                meta: {
                    title: "数据概括",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/trafficAnalysis",
                component: () => import(/* webpackChunkName: "trafficAnalysis" */ "@/views/data/trafficAnalysis.vue"),
                name: "trafficAnalysis",
                meta: {
                    title: "流量分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/tradeAnalysis",
                component: () => import(/* webpackChunkName: "tradeAnalysis" */ "@/views/data/tradeAnalysis.vue"),
                name: "tradeAnalysis",
                meta: {
                    title: "交易分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/serviceAnalysis",
                component: () => import(/* webpackChunkName: "serviceAnalysis" */ "@/views/data/serviceAnalysis.vue"),
                name: "serviceAnalysis",
                meta: {
                    title: "服务分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/userAnalysis",
                component: () => import(/* webpackChunkName: "userAnalysis" */ "@/views/data/userAnalysis.vue"),
                name: "userAnalysis",
                meta: {
                    title: "用户分析",
                    icon: "el-icon-data",
                }
            },


            /*
             * 用户管理
            */

            {
                path: "invited",
                component: () => import(/* webpackChunkName: "invited" */ "@/views/user/invited/invited.vue"),
                name: "invited",
                meta: {
                    title: "邀请奖励",
                    icon: "el-icon-help",
                }
            },
            {
                path: "userlist",
                component: () => import(/* webpackChunkName: "userlist" */ "@/views/user/userList/userList.vue"),
                name: "UserList",
                meta: {
                    title: "用户列表",
                    icon: "el-icon-help",
                }
            },

            {
                path: "save-boss",
                component: () => import(/* webpackChunkName: "userlist" */ "@/views/user/save-boss/save-boss.vue"),
                name: "save-boss",
                meta: {
                    title: "存单老板",
                    icon: "el-icon-help",
                }
            },
            {
                path: "boss-balance",
                component: () => import(/* webpackChunkName: "boss-balance" */ "@/views/user/balance/bossBalance.vue"),
                name: "BossBalance",
                meta: {
                    title: "老板余额",
                    icon: "el-icon-help",
                }
            },
            {
                path: "talent-list",
                component: () => import(/* webpackChunkName: "talent-list" */ "@/views/user/talent/talent-list.vue"),
                name: "TalentList",
                meta: {
                    title: "大神列表",
                    icon: "el-icon-help",
                }
            },
            {
                path: "userinfo",
                component: () => import(/* webpackChunkName: "userinfo" */ "@/views/user/userList/userInfo/userInfo.vue"),
                name: "UserInfo",
                meta: {
                    title: "用户信息",
                    parentRoute: "/userlist",
                    cache: false
                },
            },
            {
                path: "serviceauth",
                component: () => import(/* webpackChunkName: "serviceauth" */ "@/views/user/auth/serviceAuth.vue"),
                name: "ServiceAuth",
                meta: {
                    title: "服务认证",
                    icon: "el-icon-help",
                }
            },
            {
                path: "faceRealnameuth",
                component: () => import(/* webpackChunkName: "faceRealnameuth" */ "@/views/user/auth/faceRealnameuth.vue"),
                name: "FaceRealnameuth",
                meta: {
                    title: "人脸实名认证",
                    icon: "el-icon-help",
                }
            },
            {
                path: "realnameauth",
                component: () => import(/* webpackChunkName: "realnameauth" */ "@/views/user/auth/realNameAuth.vue"),
                name: "RealNameAuth",
                meta: {
                    title: "实名资料认证",
                    icon: "el-icon-help",
                }
            },
            {
                path: "changeservice",
                component: () => import(/* webpackChunkName: "changeservice" */ "@/views/user/auth/changeService.vue"),
                name: "ChangeService",
                meta: {
                    title: "修改服务审核",
                    icon: "el-icon-help",
                }
            },
            {
                path: "changepersonaldata",
                component: () => import(/* webpackChunkName: "changepersonaldata" */ "@/views/user/auth/changePersonalData.vue"),
                name: "ChangePersonalData",
                meta: {
                    title: "修改个人资料",
                    icon: "el-icon-help",
                    cache: false
                }
            },
            {
                path: "changrRealName",
                component: () => import(/* webpackChunkName: "changrRealName" */ "@/views/user/auth/changrRealName.vue"),
                name: "changrRealName",
                meta: {
                    title: "实名认证审核",
                    icon: "el-icon-help",
                }
            },

            {
                path: "examineList",
                component: () => import(/* webpackChunkName: "changepersonaldata" */ "@/views/user/auth/examineList.vue"),
                name: "ExamineList",
                meta: {
                    title: "游戏名片审核",
                    icon: "el-icon-help",
                }
            },
            {
                path: "changeCertified",
                component: () => import(/* webpackChunkName: "changepersonaldata" */ "@/views/user/auth/changeCertified.vue"),
                name: "changeCertified",
                meta: {
                    title: "认证技能服务",
                    icon: "el-icon-help",
                }
            },
            {
                path: "libraryreview",
                component: () => import(/* webpackChunkName: "changepersonaldata" */ "@/views/user/auth/libraryReview.vue"),
                name: "Libraryreview",
                meta: {
                    title: "作品库审核",
                    icon: "el-icon-help",
                }
            },
            {
                path: "enterprise",
                component: () => import(/* webpackChunkName: "changepersonaldata" */ "@/views/user/auth/enterprise.vue"),
                name: "Enterprise",
                meta: {
                    title: "企业认证",
                    icon: "el-icon-help",
                }
            },
            {
                path: "alipay",
                component: () => import(/* webpackChunkName: "changepersonaldata" */ "@/views/user/auth/alipay.vue"),
                name: "Alipay",
                meta: {
                    title: "支付宝认证",
                    icon: "el-icon-help",
                }
            },
            {
                path: "clustering",
                component: () => import(/* webpackChunkName: "clustering" */ "@/views/user/userOperate/clustering.vue"),
                name: "Clustering",
                meta: {
                    title: "用户分群",
                    icon: "el-icon-help",
                }
            },
            {
                path: "buildperson",
                component: () => import(/* webpackChunkName: "buildperson" */ "@/views/user/userOperate/other/buildPerson.vue"),
                name: "BuildPerson",
                meta: {
                    title: "新建人群",
                    parentRoute: "/clustering",
                    cache: false
                }
            },
            {
                path: "plan",
                component: () => import(/* webpackChunkName: "plan" */ "@/views/user/userOperate/plan.vue"),
                name: "Plan",
                meta: {
                    title: "运营计划",
                    icon: "el-icon-help",
                }
            },
            {
                path: "addplan",
                component: () => import(/* webpackChunkName: "addplan" */ "@/views/user/userOperate/other/addPlan.vue"),
                name: "AddPlan",
                meta: {
                    title: "新建计划",
                    parentRoute: "/clustering",
                    cache: false
                }
            },
            {
                path: "label",
                component: () => import(/* webpackChunkName: "label" */ "@/views/user/userOperate/label.vue"),
                name: "Label",
                meta: {
                    title: "标签管理",
                    icon: "el-icon-help",
                }
            },
            {
                path: "addlabel",
                component: () => import(/* webpackChunkName: "addlabel" */ "@/views/user/userOperate/other/addLabel.vue"),
                name: "AddLabel",
                meta: {
                    title: "新建标签",
                    parentRoute: "/clustering",
                    cache: false
                }
            },
            {
                path: "waitingdeal",
                component: () => import(/* webpackChunkName: "waitingdeal" */ "@/views/user/reportmanage/waitingDeal.vue"),
                name: "WaitingDeal",
                meta: {
                    title: "待处理举报",
                    icon: "el-icon-help",
                }
            },
            {
                path: "finishdeal",
                component: () => import(/* webpackChunkName: "finishdeal" */ "@/views/user/reportmanage/finishDeal.vue"),
                name: "FinishDeal",
                meta: {
                    title: "已处理举报",
                    icon: "el-icon-help",
                }
            },
            {
                path: "discountlist",
                component: () => import(/* webpackChunkName: "discountlist" */ "@/views/user/discount/discountList.vue"),
                name: "DiscountList",
                meta: {
                    title: "优惠券列表",
                    icon: "el-icon-help",
                }
            },
            {
                path: "editdiscount",
                component: () => import(/* webpackChunkName: "editdiscount" */ "@/views/user/discount/editDiscount.vue"),
                name: "EditDiscount",
                meta: {
                    title: "编辑优惠券",
                    parentRoute: "/discountlist",
                    cache: false
                },
            },
            {
                path: "discountisused",
                component: () => import(/* webpackChunkName: "discountisused" */ "@/views/user/discount/discountIsused.vue"),
                name: "DiscountIsused",
                meta: {
                    title: "优惠券领取/使用列表",
                    icon: "el-icon-help",
                }
            },
            {
                path: "newfeed",
                component: () => import(/* webpackChunkName: "newfeed" */ "@/views/user/feedBack/newFeed.vue"),
                name: "NewFeed",
                meta: {
                    title: "最新反馈",
                    icon: "el-icon-help",
                }
            },
            {
                path: "replyfeed",
                component: () => import(/* webpackChunkName: "replyfeed" */ "@/views/user/feedBack/replyFeed.vue"),
                name: "ReplyFeed",
                meta: {
                    title: "已回复反馈",
                    icon: "el-icon-help",
                }
            },
            {
                path: "destroy",
                component: () => import(/* webpackChunkName: "destroy" */ "@/views/user/destroy/destroy.vue"),
                name: "Destroy",
                meta: {
                    title: "销毁记录",
                    icon: "el-icon-help",
                }
            },
            {
                path: "loginMsg",
                component: () => import(/* webpackChunkName: "loginMsg" */ "@/views/user/loginMsg/loginInfo.vue"),
                name: "LoginMsg",
                meta: {
                    title: "登录日志",
                    icon: "el-icon-help",
                }
            },
            {
                path: "runrecord",
                component: () => import(/* webpackChunkName: "destroy" */ "@/views/user/runRecord/runRecord.vue"),
                name: "RunRecord",
                meta: {
                    title: "APP启动日志",
                    icon: "el-icon-help",
                }
            },
            {
                path: "withdrawal",
                component: () => import(/* webpackChunkName: "withdrawal" */ "@/views/user/withDrawal/withDrawal.vue"),
                name: "withDrawal",
                meta: {
                    title: "提现绑定",
                    icon: "el-icon-help",
                }
            },
            {
                path: "merchant",
                component: () => import(/* webpackChunkName: "merChant" */ "@/views/user/merChant/merChant.vue"),
                name: "merChant",
                meta: {
                    title: "商家绑定",
                    icon: "el-icon-help",
                }
            },
            {
                path: "rewardTrend",
                component: () => import(/* webpackChunkName: "merChant" */ "@/views/user/reward/rewardTrend.vue"),
                name: "rewardTrend",
                meta: {
                    title: "打赏趋势",
                    icon: "el-icon-help",
                }
            },
            {
                path: "reward",
                component: () => import(/* webpackChunkName: "merChant" */ "@/views/user/reward/reward.vue"),
                name: "reward",
                meta: {
                    title: "打赏查询",
                    icon: "el-icon-help",
                }
            },
            {
                path: "evaluation",
                component: () => import(/* webpackChunkName: "merChant" */ "@/views/user/evaluation/evaluation.vue"),
                name: "evaluation",
                meta: {
                    title: "评价列表",
                    icon: "el-icon-help",
                }
            },
            {
                path: "evaluation-trend",
                component: () => import(/* webpackChunkName: "merChant" */ "@/views/user/evaluation/evaluationTrend.vue"),
                name: "evaluationTrend",
                meta: {
                    title: "评价趋势",
                    icon: "el-icon-help",
                }
            },
            {
                path: "evaluation-new",
                component: () => import(/* webpackChunkName: "evaluation-new" */ "@/views/user/evaluation-new/evaluationNew.vue"),
                name: "evaluationNew",
                meta: {
                    title: "服务评价",
                    icon: "el-icon-help",
                }
            },
            {
                path: "check-service",
                component: () => import(/* webpackChunkName: "check-service" */ "@/views/user/check-manage/service.vue"),
                name: "CheckService",
                meta: {
                    title: "修改服务审核",
                }
            },
            {
                path: "check-service-wap",
                component: () => import(/* webpackChunkName: "check-service" */ "@/views/user/check-manage/wap.vue"),
                name: "CheckServiceWap",
                meta: {
                    title: "手机端服务审核",
                }
            },
            {
                path: "coupon",
                component: () => import(/* webpackChunkName: "merChant" */ "@/views/sell/coupon.vue"),
                name: "coupon",
                meta: {
                    title: "优惠券",
                }
            },

            /*
             * 财务管理
            */
            {
                path: "rechargeMoney",
                component: () => import(/* webpackChunkName: "rechargeMoney" */ "@/views/money/rechargeMoney.vue"),
                name: "RechargeMoney",
                meta: {
                    title: "资金充值",
                    icon: "icon-caiwu",
                    cache: false
                }
            },
            {
                path: "moneydetail",
                component: () => import(/* webpackChunkName: "moneydetail" */ "@/views/money/moneyDetail.vue"),
                name: "MoneyDetail",
                meta: {
                    title: "资金明细",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "moneyDetailEmployee",
                component: () => import(/* webpackChunkName: "moneyDetailEmployee" */ "@/views/money/moneyDetailEmployee.vue"),
                name: "moneyDetailEmployee",
                meta: {
                    title: "充值业绩",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "accountrecord",
                component: () => import(/* webpackChunkName: "accountrecord" */ "@/views/money/accountRecord.vue"),
                name: "AccountRecord",
                meta: {
                    title: "结算记录",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "orderOpt",
                component: () => import(/* webpackChunkName: "orderOpt" */ "@/views/trade/order-opt.vue"),
                name: "orderOpt",
                meta: {
                    title: "订单核算",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "outputmoney",
                component: () => import(/* webpackChunkName: "outputmoney" */ "@/views/money/outputMoney.vue"),
                name: "OutputMoney",
                meta: {
                    title: "提现管理",
                    icon: "icon-caiwu",
                }
            },

            /*
             * 系统管理
            */
            {
                path: "version",
                component: () => import(/* webpackChunkName: "version" */ "@/views/permission/system/version.vue"),
                name: "Version",
                meta: {
                    title: "版本管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "sensitive",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/sensitiveWords.vue"),
                name: "Sensitive",
                meta: {
                    title: "敏感词管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "admin-config",
                component: () => import(/* webpackChunkName: "admin" */ "@/views/permission/system/config/admin.vue"),
                name: "Admin",
                meta: {
                    title: "后台配置",
                    cache: false
                }
            },
            {
                path: "officialweb-config",
                component: () => import(/* webpackChunkName: "officialWeb" */ "@/views/permission/system/config/officialWeb.vue"),
                name: "OfficialWeb",
                meta: {
                    title: "官网配置",
                    cache: false
                }
            },
            {
                path: "minipro-config",
                component: () => import(/* webpackChunkName: "officialWeb" */ "@/views/permission/system/config/minipro.vue"),
                name: "minipro",
                meta: {
                    title: "小程序配置",
                    cache: false
                }
            },
            {
                path: "officialaccount-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/officialAccount.vue"),
                name: "OfficialAccount",
                meta: {
                    title: "公众号配置",
                    cache: false
                }
            },
            {
                path: "application-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/app.vue"),
                name: "Application",
                meta: {
                    title: "APP配置",
                    cache: false
                }
            },
            {
                path: "customer-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/customer.vue"),
                name: "CustomerConfig",
                meta: {
                    title: "客服配置",
                    cache: false
                }
            },
            {
                path: "order-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/order.vue"),
                name: "OrderConfig",
                meta: {
                    title: "订单配置",
                    cache: false
                }
            },
            {
                path: "lottery-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/lottery.vue"),
                name: "lotteryConfig",
                meta: {
                    title: "派单抽奖",
                    cache: false
                }
            },
            {
                path: "lottery-day",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/lottery-day.vue"),
                name: "lotteryDayConfig",
                meta: {
                    title: "每日抽奖",
                    cache: false
                }
            },
            {
                path: "send_mp_template",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/send_mp_template.vue"),
                name: "send_mp_template",
                meta: {
                    title: "发送模板消息",
                    cache: false
                }
            },

            {
                path: "mp-tqc-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/mp-tqc-config.vue"),
                name: "mp-tqc-config",
                meta: {
                    title: "特勒处配置",
                    cache: false
                }
            },
            {
                path: "topicmanage",
                component: () => import(/* webpackChunkName: "topicmanage" */ "@/views/permission/resource/topicManage.vue"),
                name: "TopicManage",
                meta: {
                    title: "话题管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "face",
                component: () => import(/* webpackChunkName: "face" */ "@/views/permission/resource/face.vue"),
                name: "face",
                meta: {
                    title: "捏脸帖子",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "add-face",
                component: () => import(/* webpackChunkName: "add-face" */ "@/views/permission/resource/add-face.vue"),
                name: "add-face",
                meta: {
                    title: "新建文章",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "app-banner",
                component: () => import(/* webpackChunkName: "Appbanner" */ "@/views/permission/resource/banner.vue"),
                name: "Appbanner",
                meta: {
                    title: "APP轮播图",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "message",
                component: () => import(/* webpackChunkName: "message" */ "@/views/permission/message/message.vue"),
                name: "Message",
                meta: {
                    title: "短信通知",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "helper",
                component: () => import(/* webpackChunkName: "helper" */ "@/views/permission/message/helper.vue"),
                name: "Helper",
                meta: {
                    title: "街姐助手",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "order",
                component: () => import(/* webpackChunkName: "order" */ "@/views/permission/message/order.vue"),
                name: "Order",
                meta: {
                    title: "订单消息",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "staff",
                component: () => import(/* webpackChunkName: "employee" */ "@/views/permission/staff/staff.vue"),
                name: "Staff",
                meta: {
                    title: "员工管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "apiAbnormal",
                component: () => import(/* webpackChunkName: "employee" */ "@/views/permission/apiAbnormal/apiAbnormal.vue"),
                name: "apiAbnormal",
                meta: {
                    title: "接口超时",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "roleEdit",
                component: () => import(/* webpackChunkName: "roleEdit" */ "@/views/permission/staff/roleEdit.vue"),
                name: "RoleEdit",
                meta: {
                    title: "角色编辑",
                    parentRoute: "/role",
                    cache: false
                }
            },
            {
                path: "role",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/staff/role.vue"),
                name: "Role",
                meta: {
                    title: "角色管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "customerService",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/staff/customerService.vue"),
                name: "CustomerService",
                meta: {
                    title: "客服管理",
                    icon: "icon-caiwu",
                }
            },

            {
                path: "goodsManag",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/voiceChat/goodsManag.vue"),
                name: "GoodsManag",
                meta: {
                    title: "礼物管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "roomManag",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/voiceChat/roomManag.vue"),
                name: "RoomManag",
                meta: {
                    title: "房间管理",
                    icon: "icon-caiwu",
                }
            },


            {
                path: "customerEdit",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/staff/customerEdit.vue"),
                name: "CustomerEdit",
                meta: {
                    title: "编辑客服",
                    parentRoute: "/customerService",
                    cache: false
                }
            },
            {
                path: "menulist",
                component: () => import(/* webpackChunkName: "menulist" */ "@/views/permission/staff/menuList.vue"),
                name: "menulist",
                meta: {
                    title: "菜单管理",
                    icon: "el-icon-s-tools",
                }
            },
            {
                path: "userlog",
                component: () => import(/* webpackChunkName: "userlog" */ "@/views/permission/logs/userLog.vue"),
                name: "UserLog",
                meta: {
                    title: "用户操作日志",
                }
            },
            {
                path: "stafflog",
                component: () => import(/* webpackChunkName: "stafflog" */ "@/views/permission/logs/staffLog.vue"),
                name: "StaffLog",
                meta: {
                    title: "用户操作日志",
                }
            },
            {
                path: "importantlog",
                component: () => import(/* webpackChunkName: "importantlog" */ "@/views/permission/logs/importantLog.vue"),
                name: "Importantlog",
                meta: {
                    title: "重要操作日志",
                }
            },
            {
                path: "dynamic",
                component: () => import(/* webpackChunkName: "dynamic" */ "@/views/permission/content/dynamic.vue"),
                name: "Dynamic",
                meta: {
                    icon: "icon-caiwu",
                    title: "动态列表",
                }
            },
            {
                path: "comments",
                component: () => import(/* webpackChunkName: "comments" */ "@/views/permission/content/comments.vue"),
                name: "Comments",
                meta: {
                    title: "评论列表",
                    icon: "icon-caiwu"
                }
            },
            {
                path: "demand",
                component: () => import(/* webpackChunkName: "demand" */ "@/views/permission/content/demand.vue"),
                name: "Demand",
                meta: {
                    title: "需求列表",
                    icon: "icon-caiwu"
                }
            },
            {
                path: "chat",
                component: () => import(/* webpackChunkName: "chat" */ "@/views/permission/content/chat.vue"),
                name: "Chat",
                meta: {
                    title: "聊天记录",
                    icon: "icon-caiwu"
                }
            },
            {
                path: "chatroom",
                component: () => import(/* webpackChunkName: "chatroom" */ "@/views/chat/chat.vue"),
                name: "ChatRoom",
                meta: { title: "客服会话", icon: "icon-caiwu", cache: false }
            },

            /**
             * 帮助中心
             */
            {
                path: "category",
                component: () => import(/* webpackChunkName: "category" */ "@/views/help/category.vue"),
                name: "category",
                meta: {
                    title: "分类管理",
                    icon: "el-icon-s-custom",
                }
            },
            {
                path: "articles",
                component: () => import(/* webpackChunkName: "articles" */ "@/views/help/articles.vue"),
                name: "articles",
                meta: {
                    title: "文章列表",
                    icon: "el-icon-s-custom",
                }
            },
            {
                path: "modify",
                component: () => import(/* webpackChunkName: "modify" */ "@/views/help/modify.vue"),
                name: "modify",
                meta: {
                    title: "编辑文章",
                    // parentRoute: "/ordermanage",
                    cache: false
                }
            },

            /*
            * 白名单
            */
            {
                path: "whitelist",
                component: () => import(/* webpackChunkName: "whitelist" */ "@/views/permission/whiteList/whiteList.vue"),
                name: "WhiteList",
                meta: {
                    title: "白名单",
                    icon: "el-icon-s-custom",
                }
            },

            /**
             * 问题管理
             */
            {
                path: "question-list",
                component: () => import(/* webpackChunkName: "question-list" */ "@/views/permission/questionManage/question.vue"),
                name: "Question",
                meta: {
                    title: "问题列表",
                }
            },
            {
                path: "question-answer",
                component: () => import(/* webpackChunkName: "question-answer" */ "@/views/permission/questionManage/answer.vue"),
                name: "questionAnswer",
                meta: {
                    title: "回答列表",
                }
            }, {
                path: "question-comment",
                component: () => import(/* webpackChunkName: "question-comment" */ "@/views/permission/questionManage/comment.vue"),
                name: "QuestionComment",
                meta: {
                    title: "评论列表",
                }
            },
            /**
             * 雇员管理
             */
            {
                path: 'seller',
                component: () => import(/* webpackChunkName: "seller" */ "@/views/sell/seller.vue"),
                name: 'seller',
                meta: {
                    title: '雇员管理'
                }
            },
            {
                path: 'achievement',
                component: () => import(/* webpackChunkName: "achievement" */ "@/views/sell/achievement.vue"),
                name: 'achievement',
                meta: {
                    title: '业绩统计'
                }
            },
            {
                path: 'achievement-search',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/sell/achievement-search.vue'),
                name: 'achievement-search',
                meta: {
                    title: '业绩列表'
                }
            },
            {
                path: 'achievement-trend',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/sell/achievement-trend.vue'),
                name: 'achievement-trend',
                meta: {
                    title: '业绩趋势'
                }
            },
            {
                path: 'recharge-search',
                component: () => import(/* webpackChunkName: "recharge-search" */ '@/views/sell/recharge-search.vue'),
                name: 'recharge-search',
                meta: {
                    title: '充值列表'
                }
            },
            {
                path: 'recharge-trend',
                component: () => import(/* webpackChunkName: "recharge-search" */ '@/views/sell/recharge-trend.vue'),
                name: 'recharge-trend',
                meta: {
                    title: '充值趋势'
                }
            },
            {
                path: 'customer',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/sell/customer.vue'),
                name: 'customer',
                meta: {
                    title: '客户资源'
                }
            },
            {
                path: 'businessman-statistics',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/sell/businessman-statistics.vue'),
                name: 'businessman-statistics',
                meta: {
                    title: '商家统计'
                }
            },
            {
                path: 'service-setting',
                component: () => import(/* webpackChunkName: "service-setting" */ '@/views/sell/service/service-setting.vue'),
                name: 'ServiceSetting',
                meta: {
                    title: '服务配置'
                }
            },
            {
                path: 'service-manage',
                component: () => import(/* webpackChunkName: "service-setting" */ '@/views/sell/service/service-manage.vue'),
                name: 'ServiceManage',
                meta: {
                    title: '服务配置'
                }
            },
            {
                path: "service-edit",
                component: () => import(/* webpackChunkName: "userinfo" */ "@/views/sell/service/service-edit.vue"),
                name: "serviceEdit",
                meta: {
                    title: "新建服务",
                    parentRoute: "/service-manage",
                    cache: false
                },
            },
            {
                path: 'service-setting-edit',
                component: () => import(/* webpackChunkName: "service-setting-edit" */ '@/views/sell/service/edit.vue'),
                name: 'ServiceSettingEdit',
                meta: {
                    title: '编辑配置',
                    parentRoute: "/service-setting"
                }
            },

            /**
             * 交易管理
             */

            //在线派单
            {
                path: 'trade-list',
                component: () => import('@/views/trade/trade-list.vue'),
                name: 'trade-list',
                meta: {
                    title: '在线派单'
                }
            },
            //护航派单
            {
                path: 'quick-index',
                component: () => import('@/views/trade/quick-trade/quick_index.vue'),
                name: 'quick-index',
                meta: {
                    title: '护航派单'
                }
            },
            //老板上传列表
            {
                path: 'boss-rank-list',
                component: () => import('@/views/club/boss-rank/boss-rank-list.vue'),
                name: 'boss-rank-list',
                meta: {
                    title: '上传列表'
                }
            },
            //老板--列表
            {
                path: 'boss-code-list',
                component: () => import('@/views/club/boss-rank/boss-code-list.vue'),
                name: 'boss-code-list',
                meta: {
                    title: '老板列表'
                }
            },
            //邀请有奖--大神列表
            {
                path: 'invite-ds-list',
                component: () => import('@/views/club/invite-list/invite-ds-list.vue'),
                name: 'invite-ds-list',
                meta: {
                    title: '邀请有奖-大神列表'
                }
            },
            //邀请有奖--老板列表
            {
                path: 'invite-bs-list',
                component: () => import('@/views/club/invite-list/invite-bs-list.vue'),
                name: 'invite-bs-list',
                meta: {
                    title: '邀请有奖-老板列表'
                }
            },
            //邀请有奖--消费列表
            {
                path: 'invite-expend-list',
                component: () => import('@/views/club/invite-list/invite-expend-list.vue'),
                name: 'invite-expend-list',
                meta: {
                    title: '邀请有奖-消费列表'
                }
            },
            //邀请有奖--优惠券列表
            {
                path: 'invite-coupon-list',
                component: () => import('@/views/club/invite-list/invite-coupon-list.vue'),
                name: 'invite-coupon-list',
                meta: {
                    title: '邀请有奖-优惠券列表'
                }
            },
            //评分列表
            {
                path: 'user-score-list',
                component: () => import('@/views/club/score/score-list.vue'),
                name: 'user-score-list',
                meta: {
                    title: '评分列表'
                }
            },
            //跑刀派单
            {
                path: 'pd-index',
                component: () => import('@/views/trade/quick-trade/pd_index.vue'),
                name: 'pd-index',
                meta: {
                    title: '跑刀派单'
                }
            },
            //手机端订单分类
            {
                path: 'wap-order-category',
                component: () => import('@/views/club/order/category/wap_category.vue'),
                name: 'wap-order-category',
                meta: {
                    title: '手机端订单分类'
                }
            },
            //
            {
                path: 'club-product-list',
                component: () => import('@/views/club/product/product_list.vue'),
                name: 'club-product-list',
                meta: {
                    title: '商品编辑'
                }
            },
            //物品模版
            {
                path: 'itemTemplate',
                component: () => import('@/views/club/itemTemplate/itemTemplate.vue'),
                name: 'itemTemplate',
                meta: {
                    title: '物品模版'
                }
            },
            //账号租售
            {
                path: 'accountRs',
                component: () => import('@/views/club/accountRs/accountRs.vue'),
                name: 'accountRs',
                meta: {
                    title: '账号租售'
                }
            },
            //记账列表
            {
                path: 'account-list',
                component: () => import('@/views/club/account/account-list.vue'),
                name: 'account-list',
                meta: {
                    title: '记账列表'
                }
            },
            //工作记录
            {
                path: 'work-log',
                component: () => import('@/views/club/work-log/work-log.vue'),
                name: 'work-log',
                meta: {
                    title: '工作记录'
                }
            },
            //平台工单
            {
                path: 'ticket-list',
                component: () => import('@/views/club/ticket/ticket-list.vue'),
                name: 'ticket-list',
                meta: {
                    title: '平台工单'
                }
            },
            //活动列表
            {
                path: 'actionIndex',
                component: () => import('@/views/club/action/action_index.vue'),
                name: 'actionIndex',
                meta: {
                    title: '活动列表'
                }
            },
            //节日活动
            {
                path: 'festivalIndex',
                component: () => import('@/views/club/action/festival_index.vue'),
                name: 'festivalIndex',
                meta: {
                    title: '节日活动'
                }
            },
            //线下派单
            {
                path: 'offline-order',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/trade/offline-order.vue'),
                name: 'offline-order',
                meta: {
                    title: '线下派单'
                }
            },
            {
                path: 'play-order',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/trade/play-order.vue'),
                name: 'play-order',
                meta: {
                    title: '约玩订单'
                }
            },
            {
                path: 'play-sendList',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/trade/child/play-operate-order.vue'),
                name: 'play-sendList',
                meta: {
                    title: '试音列表'
                }
            },
            {
                path: 'self-order',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/trade/self-order.vue'),
                name: 'self-order',
                meta: {
                    title: '自助下单'
                }
            },
            //接单看板
            {
                path: 'trade-board',
                component: () => import(/* webpackChunkName: "achievement-search" */ '@/views/trade/trade-board.vue'),
                name: 'trade-board',
                meta: {
                    title: '接单看板'
                }
            },
            {
                path: 'talent-status',
                component: () => import(/* webpackChunkName: "talent-status" */ '@/views/trade/talent-status'),
                name: 'TalentStatus',
                meta: {
                    title: '大神状态'
                }
            },
            {
                path: 'talent-deduction',
                component: () => import(/* webpackChunkName: "talent-deduction" */ '@/views/trade/talent-deduction'),
                name: 'TalentDeduction',
                meta: {
                    title: '大神扣款'
                }
            },
            {
                path: 'plugin-unit',
                component: () => import(/* webpackChunkName: "talent-deduction" */ '@/views/plugin-manage/plugin-unit'),
                name: 'PluginUni',
                meta: {
                    title: '插件管理'
                }
            },
            {
                path: 'edit-unit',
                component: () => import(/* webpackChunkName: "talent-deduction" */ '@/views/plugin-manage/edit-unit'),
                name: 'EditUni',
                meta: {
                    title: '修改插件'
                }
            },
            {
                path: "sms-template",
                component: () => import(/* webpackChunkName: "message" */ "@/views/permission/message/sms-template.vue"),
                name: "SmsTemplate",
                meta: {
                    title: "短信模板",
                }
            },
            {
                path: "withdrawal-config",
                component: () => import(/* webpackChunkName: "order" */ "@/views/money/withdrawal-config.vue"),
                name: "WithdrawalConfig",
                meta: {
                    title: "提现管理配置",
                    icon: "icon-caiwu",
                }
            },

            /**
             * 俱乐部管理  -- 审核
             */
            {
                path: "club-validate-list",
                component: () => import(/* webpackChunkName: "club-validate-list" */ "@/views/club/validate/club.vue"),
                name: "clubValidateList",
                meta: {
                    title: "俱乐部-审核列表",
                }
            },
            {
                path: "club-validate-master-list",
                component: () => import(/* webpackChunkName: "club-validate-list" */ "@/views/club/validate/master.vue"),
                name: "clubValidateMasterList",
                meta: {
                    title: "考官-审核列表",
                }
            },
            {
                path: "club-validate-manager-list",
                component: () => import(/* webpackChunkName: "club-validate-list" */ "@/views/club/validate/manager.vue"),
                name: "clubValidateManagerList",
                meta: {
                    title: "测评员-审核列表",
                }
            },
            {
                path: "club-validate-god-list",
                component: () => import(/* webpackChunkName: "club-validate-list" */ "@/views/club/validate/god.vue"),
                name: "clubValidateGodList",
                meta: {
                    title: "大神-审核列表",
                }
            },
            /**
             * 俱乐部管理  -- 列表
             */
            {
                path: "club-list",
                component: () => import(/* webpackChunkName: "club-list" */ "@/views/club/list/club.vue"),
                name: "club-list",
                meta: {
                    title: "成员列表",
                }
            },
            {
                path: "club-master-list",
                component: () => import(/* webpackChunkName: "club-list" */ "@/views/club/list/master.vue"),
                name: "clubMasterList",
                meta: {
                    title: "考官-列表",
                }
            },
            {
                path: "club-manager-list",
                component: () => import(/* webpackChunkName: "club-list" */ "@/views/club/list/manager.vue"),
                name: "clubManagerList",
                meta: {
                    title: "测评员-列表",
                }
            },
            {
                path: "club-god-list",
                component: () => import(/* webpackChunkName: "club-list" */ "@/views/club/list/god.vue"),
                name: "clubGodList",
                meta: {
                    title: "大神-列表",
                }
            },
            /**
             * 俱乐部游戏 -- 列表
             */
            {
                path: "club-game-list",
                component: () => import(/* webpackChunkName: "club-game-list" */ "@/views/club/game/list.vue"),
                name: "club-game-list",
                meta: {
                    title: "游戏管理-列表",
                }
            },
            {
                path: "club-game-server-detail",
                component: () => import(/* webpackChunkName: "club-game-list" */ "@/views/club/game/server/detail.vue"),
                name: "clubGameServerDetail",
                meta: {
                    title: "服务列表",
                    parentRoute: "/club-game-list",
                    cache: false
                },
            },

            /**
             * 俱乐部游戏 -- 小游戏列表
             */
            {
                path: "club-minigame-list",
                component: () => import(/* webpackChunkName: "club-minigame-list" */ "@/views/club/minigame/list.vue"),
                name: "club-minigame-list",
                meta: {
                    title: "小游戏列表",
                }
            },

            /**
             * 俱乐部游戏 -- 小游戏 -- 创建列表
             */
            {
                path: "club-minigame-create-list",
                component: () => import(/* webpackChunkName: "club-minigame-create-list" */ "@/views/club/minigame/create-list.vue"),
                name: "club-minigame-create-list",
                meta: {
                    title: "小游戏-创建列表",
                }
            },

            /**
             * 酒店管理
             */
            {
                path: "hotel-order",
                component: () => import(/* webpackChunkName: "hotel-order" */ "@/views/club/hotel/hotel-order.vue"),
                name: "hotel-order",
                meta: {
                    title: "订单数据",
                    icon: "el-icon-s-order",
                }
            },
            {
                path: "hotel-qrcode",
                component: () => import(/* webpackChunkName: "hotel-qrcode" */ "@/views/club/hotel/hotel-qrcode.vue"),
                name: "hotel-qrcode",
                meta: {
                    title: "物料管理",
                    icon: "el-icon-s-grid",
                }
            },
            {
                path: "hotel-qrcode-data-detail",
                component: () => import(/* webpackChunkName: "hotel-qrcode-data-detail" */ "@/views/club/hotel/hotel-qrcode-data-detail.vue"),
                name: "hotel-qrcode-data-detail",
                meta: {
                    title: "二维码数据详情",
                    parentRoute: "/hotel-qrcode",
                    cache: false
                }
            },
            {
                path: "hotel-qrcode-bind-list",
                component: () => import(/* webpackChunkName: "hotel-qrcode-bind-list" */ "@/views/club/hotel/hotel-qrcode-bind-list.vue"),
                name: "hotel-qrcode-bind-list",
                meta: {
                    title: "用户列表",
                    icon: "el-icon-s-custom",
                }
            },
            {
                path: "hotel-scan-log",
                component: () => import(/* webpackChunkName: "hotel-scan-log" */ "@/views/club/hotel/hotel-scan-log.vue"),
                name: "hotel-scan-log",
                meta: {
                    title: "扫码日志",
                    icon: "el-icon-document",
                }
            },
            {
                path: "hotel-commission",
                component: () => import(/* webpackChunkName: "hotel-commission" */ "@/views/club/hotel/hotel-commission.vue"),
                name: "hotel-commission",
                meta: {
                    title: "佣金结算",
                    icon: "el-icon-s-finance",
                }
            },
            {
                path: "hotel-accounts",
                component: () => import(/* webpackChunkName: "hotel-accounts" */ "@/views/club/hotel/hotel-accounts.vue"),
                name: "hotel-accounts",
                meta: {
                    title: "酒店管理",
                    icon: "el-icon-office-building",
                }
            },
            {
                path: "hotel-add",
                component: () => import(/* webpackChunkName: "hotel-edit" */ "@/views/club/hotel/hotel-edit.vue"),
                name: "hotel-add",
                meta: {
                    title: "添加账号",
                    parentRoute: "/hotel-accounts",
                    cache: false
                }
            },
            {
                path: "hotel-detail",
                component: () => import(/* webpackChunkName: "hotel-detail" */ "@/views/club/hotel/hotel-detail.vue"),
                name: "hotel-detail",
                meta: {
                    title: "账号详情",
                    parentRoute: "/hotel-accounts",
                    cache: false
                }
            },
            {
                path: "hotel-edit",
                component: () => import(/* webpackChunkName: "hotel-edit" */ "@/views/club/hotel/hotel-edit.vue"),
                name: "hotel-edit",
                meta: {
                    title: "编辑",
                    parentRoute: "/hotel-accounts",
                    cache: false
                }
            },
            {
                path: "hotel-city",
                component: () => import(/* webpackChunkName: "hotel-city" */ "@/views/club/hotel/hotel-city.vue"),
                name: "hotel-city",
                meta: {
                    title: "城市管理",
                    icon: "el-icon-location",
                }
            },

            /**
             * 广告商管理
             */
            {
                path: "adsense-user",
                component: () => import(/* webpackChunkName: "adsense-user" */ "@/views/club/adsense/adsense-user.vue"),
                name: "adsense-user",
                meta: {
                    title: "用户"
                }
            },
            {
                path: "adsense-page",
                component: () => import(/* webpackChunkName: "adsense-page" */ "@/views/club/adsense/adsense-page.vue"),
                name: "adsense-page",
                meta: {
                    title: "广告商产品"
                }
            },
            {
                path: "adsense-url",
                component: () => import(/* webpackChunkName: "adsense-url" */ "@/views/club/adsense/adsense-url.vue"),
                name: "adsense-url",
                meta: {
                    title: "广告商链接"
                }
            },
            {
                path: "adsense-kf",
                component: () => import(/* webpackChunkName: "adsense-kf" */ "@/views/club/adsense/adsense-kf.vue"),
                name: "adsense-kf",
                meta: {
                    title: "广告商客服"
                }
            },
            {
                path: "adsense-banner",
                component: () => import(/* webpackChunkName: "adsense-banner" */ "@/views/club/adsense/adsense-banner.vue"),
                name: "adsense-banner",
                meta: {
                    title: "轮播图"
                }
            },
            {
                path: "adsense-log",
                component: () => import(/* webpackChunkName: "adsense-log" */ "@/views/club/adsense/adsense-log.vue"),
                name: "adsense-log",
                meta: {
                    title: "操作日志"
                }
            },
            {
                path: "adsense-icon",
                component: () => import(/* webpackChunkName: "adsense-icon" */ "@/views/club/adsense/adsense-icon.vue"),
                name: "adsense-icon",
                meta: {
                    title: "快捷图标"
                }
            },
            {
                path: "adsense-limit",
                component: () => import(/* webpackChunkName: "adsense-limit" */ "@/views/club/adsense/adsense-limit.vue"),
                name: "adsense-limit",
                meta: {
                    title: "发布量限制"
                }
            },
            {
                path: "vip-type",
                component: () => import(/* webpackChunkName: "vip-type" */ "@/views/club/adsense/vip-type.vue"),
                name: "vip-type",
                meta: {
                    title: "VIP套餐分类"
                }
            },
            {
                path: "vip-order",
                component: () => import(/* webpackChunkName: "vip-order" */ "@/views/club/adsense/vip-order.vue"),
                name: "vip-order",
                meta: {
                    title: "VIP开通记录"
                }
            },
        ]
    },
];


const createRouter = () =>
    new VueRouter({
        mode: 'history',
        scrollBehavior: (to, from, savedPosition) => {
            if (savedPosition) {
                return savedPosition;
            } else {
                return { x: 0, y: 0 };
            }
        },
        base: process.env.BASE_URL,
        routes: [...constantRoutes, ...asyncRoutes]
    });

const router = createRouter();

export default router;
